// Third Party
import React from 'react';
import camelCase from 'lodash/camelCase';

// Components
import { SecondaryLink } from '../../buttons';
import { HoldingIcon } from '../../common';

// Utils
import { formatLocalizedString, formatMessage } from '../../../../utils/i18n';
import QuickAddItem from '@/types/quick-add-item';

type Props = {
  items: QuickAddItem[];
  title?: string;
  sectionKey?: string;
  onAddFund: (id: string) => void;
  onOpenScreener: (proxyOption: string) => void;
};

const QuickAddList = ({ sectionKey, items, title, onAddFund, onOpenScreener }: Props) => {
  const renderItems = () =>
    items.map((item: QuickAddItem) => (
      <div className="proxy" key={item.refId}>
        <div className="proxy-holding-wrapper">
          <div className="proxy-symbol">
            <HoldingIcon type={item.type} />
            <span>{item.code}</span>
          </div>

          <SecondaryLink onClick={() => onAddFund(item.refId)}>
            <span>{formatMessage('EditPortfolioModal.AddProxy')}</span>
            <span className="visually-hidden">{formatLocalizedString(item.displayName)}</span>
          </SecondaryLink>
        </div>

        <span className="proxy-name">{formatLocalizedString(item.displayName)}</span>
      </div>
    ));

  return (
    <div className="quick-add-proxies-section">
      {title && <span className="proxy-section-title">{title}</span>}

      <div className="d-flex proxy-item-wrapper">{renderItems()}</div>

      {sectionKey !== undefined && (
        <SecondaryLink className="open-proxy-link" onClick={() => onOpenScreener(sectionKey)}>
          <span className="fund-screener-btn">{formatMessage('EditPortfolioModal.OpenScreener')}</span>
        </SecondaryLink>
      )}
    </div>
  );
};

export default QuickAddList;
